import axios from "axios"
import { utils } from "../../utils"


const Action_createOrder = (order) => async (dispatch, getState) => {

    try {

        // console.log('getState().reducer_user.user._id:', getState().reducer_user.user._id)
        const DB_id = getState().reducer_user.user._id;
        
        if(!DB_id){
            throw Error('user is empty')
        }

        dispatch({
            type: utils.constants.ORDER_CREATE_REQUEST,
            // payload: order
        })

        const { data } = await axios.post(utils.constants.API.API_ORDERS, {
            order: { DB_id, ...order }
        })

        if (data) {
            // state as DB
            dispatch({
                type: utils.constants.ORDER_CREATE_SUCCESS,
                payload: data
            })

            // clear cart
            localStorage.removeItem(utils.constants.localStorage_cart)

            dispatch({
                type: utils.constants.ORDER_CREATE_SUCCESS_CLEAT_CART,
            })

        } else {
            throw new Error('Creating order has been failed.')
        }
    } catch (error) {
        dispatch({
            type: utils.constants.ORDER_ACTION_FAIL,
            payload: error.message
        });
    }
}

const Action_order_list = () => async (dispatch) => {
    try {

        dispatch({ type: utils.constants.ORDER_LIST_REQUEST });
        const { data } = await axios.get(utils.constants.API.API_ORDERS);


        if (data?.dbOrders) {
            dispatch({
                type: utils.constants.ORDER_LIST_SUCCESS,
                payload: data.dbOrders
            })
        } else {
            throw new Error('order list failed')
        }
    } catch (error) {
        dispatch({
            type: utils.constants.ORDER_ACTION_FAIL,
            payload: error.message
        });
    }
}


const Action_order_delete = (orderID) => async (dispatch) => {

    try {
        dispatch({
            type: utils.constants.ORDER_DELETE_REQUEST
        })
        const deletedOrder = await axios.delete(utils.constants.API.API_ORDERS + '/' + orderID)
        if (deletedOrder) {
            dispatch({
                type: utils.constants.ORDER_DELETE_SUCCESS,
                payload: deletedOrder
            })
        } else {
            throw new Error('delete order action has been failed')
        }
    } catch (error) {
        dispatch({
            type: utils.constants.ORDER_ACTION_FAIL,
            payload: error.message
        });
    }
}

const Action_order_clear = () => async (dispatch) => {
    console.log('on Action_order_clear');

    try {
        dispatch({
            type: utils.constants.ORDER_CLEAR
        })
    } catch (error) {
        dispatch({
            type: utils.constants.ORDER_ACTION_FAIL,
            payload: error.message
        });
    }
}


// const serveError = (error, dispatch) => {
//     dispatch({
//         type: utils.constants.ORDER_ACTION_FAIL,
//         payload: error.message
//     });
// }


export {
    Action_createOrder,
    Action_order_list,
    Action_order_delete,
    Action_order_clear
}